<template>
  <div class="page">
    <header class="recharge-header">
      <button class="recharge-brand" type="button" @click="goHome">
        <img src="@/img/logo.svg" alt="">
        <span>Yaychat</span>
      </button>
    </header>
    <div class="c_out">
      <div class="first-bg">
        <div class="card-title">{{ $t('recharge.firstTopUpGift') }}</div>
        <div class="card-description">{{ $t('recharge.firstTopUpGiftDescription') }}</div>
        <img src="@/img/recharge/recharge_gift.webp" alt="" class="gift-icon">
      </div>
      <div class="container">
        <div class="title">{{ $t('recharge.topUp') }}</div>
        <div class="row">
          <div class="desktop-account-section">
            <div class="desktop-account-label">{{ $t('recharge.userId') }}</div>
            <div class="desktop-account-card" :class="{ 'has-user': user }">
              <div class="desktop-input-wrap" :class="{ active: user }">
                <input
                  type="text"
                  v-model="user_id"
                  class="uid_input"
                  inputmode="numeric"
                  autocomplete="off"
                  @blur="saveUid"
                  @input="checkUid"
                  @keyup.enter="$event.target.blur()"
                  :placeholder="$t('recharge.enterUserIdToTopUp')"
                />
                <button
                  v-if="user_id"
                  class="clear-user-button"
                  type="button"
                  :aria-label="$t('recharge.clearUserId')"
                  @mousedown.prevent
                  @click="clearUserInput"
                >
                  <span aria-hidden="true"></span>
                </button>
              </div>
              <div v-if="user" class="desktop-user-info">
                <img :src="user.avatar" class="circle_avatar">
                <strong class="desktop-user-name">{{ user.nickName }}</strong>
                <span v-if="isNewUser" class="first-top-up">{{ $t('recharge.firstTopUp') }}</span>
              </div>
            </div>
          </div>


          <div class="label">{{ $t('recharge.selectTopUpAmount') }}</div>
          <div v-if="productsLoading" class="value flex pc-coin-skeletons">
            <span v-for="index in 7" :key="index" class="pc-coin-skeleton skeleton-shimmer"></span>
          </div>
          <div v-else class="value flex">
            <div class="rechage_item flex-center" v-for="item in recharge_list" :key="item.id"
              :class="{ active: item.id === select_recharge_id }"
              @click="priceChangeHandle(item)">
              <div style="position: absolute;width: 150px;">
                <div class="flex-center row1" :class="{ active: item.id === select_recharge_id }">
                  <img src="@/img/jinbi.png" alt="">
                  {{ item.coin }}
                </div>
                <span class="flex-center row2">${{ (Number(item.coin) / 50).toFixed(2) }}</span>
              </div>

            </div>
          </div>
        </div>

        <div class="row">
          <div class="label">{{ $t('recharge.confirmTopUp') }}</div>

          <div class="button-container">
            <div v-if="productsLoading" class="pc-payment-skeletons">
              <span v-for="index in 3" :key="index" class="pc-payment-skeleton skeleton-shimmer"></span>
            </div>
            <!-- <div class="bank_card_btn" @click="bankCardClick">
              <div class="btn_con">
                <img src="@/img/ic_bank_card.svg" />
                Bank Card
                <span style="margin-left: 12px;">${{ select_recharge_item?.cent }}</span>
                <span class="raw-price">(${{ select_recharge_item?.coin / 50 }})</span>

                <div class="card_flag">
                  <span>37.5% OFF</span>
                </div>/
              </div>

            </div> -->

            <div v-for="item in directPayTypes" :key="item" class="pay-method-item">
              <!-- <div v-if="item == 'STRIPE'" class="stripe-pay-btn" @click="stripePayClick"> -->
              <div v-if="item == 'PAYERMAX'" class="payermax-btn" @click="payermaxClick">
                <div class="inline-layout" :class="{ loading: clickPayItem == item }">
                  <div id="loadingSpinner" class="click-loading" v-if="clickPayItem == item"></div>
                  <img src="@/img/ic_payermax.svg" class="icon" />
                  <span>{{ $t('recharge.payermax') }}</span>
                  <span style="margin-left: 12px; font-style: normal;">{{ select_recharge_item?.localPrice ?? `$${select_recharge_item?.cent}`
                    }}</span>
                  <span class="raw-price" >(${{ select_recharge_item?.coin / 50 }})</span>
                  <div class="card_flag">
                    <span>{{ $t('recharge.discount375Off') }}</span>
                  </div>
                </div>
              </div>
              <div v-else-if="item == 'STRIPE' || item == 'DIANDIAN'" class="stripe-pay-btn" @click="() => beforeStripeClick(item)">
                <div class="inline-layout">
                  <div id="loadingSpinner" class="click-loading" v-if="clickPayItem == item"></div>
                  <img src="@/img/ic_stripe.svg" class="icon" />
                  <span class="gradient-text" style="padding: 0px 5px;">{{ clickPayItem == item ? $t('recharge.paying') : $t('recharge.stripePay') }}</span>
                  <span style="margin-left: 12px;color: #333; font-style: normal;">{{ select_recharge_item?.localPrice ?? `$${select_recharge_item?.cent}` }}</span>
                  <span class="raw-price" style="color: #333;">(${{ select_recharge_item?.coin / 50 }})</span>
                </div>
                <div class="card_flag">
                  <span class="gradient-text" style="font-size: 11px;font-weight: 600;">{{ $t('recharge.discount375Off') }}</span>
                </div>
              </div>
              <!-- <div v-else-if="item == 'ASIAPAY'" class="aisapay-btn" @click="asiapayClick">
                <div class="inline-layout">
                  <div id="loadingSpinner" class="click-loading" v-if="clickPayItem == item"></div>
                  <img src="@/img/paydollar.svg" class="paydollar-icon" />
                  <span>{{ clickPayItem == item ? "Paying..." : "Paydollar" }}</span>
                </div>
              </div>
              <div v-else-if="item == 'PAYPAL'">
                <div  id="top_up_btn"></div>
              </div> -->

            </div>

            <div v-if="!productsLoading && supportedPayTypes?.includes('PAYPAL')" class="pay-method-item">
              <div class="custom_paypal_btn" @click="customPaypalClick">
                <div class="btn_con">
                  <img src="@/img/ic_paypal.svg" />
                  <span class="gradient-text">{{ $t('recharge.paypal') }}</span>
                  <span style="margin-left: 12px; font-style: normal;">{{ paypal_product_item?.localPrice }}</span>
                  <span class="raw-price">(${{ select_recharge_item.coin / 50 }})</span>
                  <div class="card_flag">
                    <span class="gradient-text" style="font-size: 11px;font-weight: 600;">{{ $t('recharge.discount285Off') }}</span>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="loading-overlay" v-if="loading">
    <div class="loader"></div>
    <span>{{ $t('recharge.coinsAreBeingDistributed') }}</span>
  </div>

  <div id="paypal-container"></div>

</template>

<script setup>
import router from '#/router'
import { computed, onMounted, ref, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { getChargeProducts, createOrder, verifyReceipt, getUser, getChargeProductIten } from "#/api/index.js"
import { toastSuccess, toastError } from "#/utils/toast"
import { weightedRandom } from "#/utils/index"
import { genrateForm } from './asiapay'
import { loadScript } from "@paypal/paypal-js";

// 禁用paypal
const disablePaypal = ref(false)

const loading = ref(false)
const productsLoading = ref(true)

// const clickStrip = ref(false)

const select_recharge_id = ref(1)
const select_recharge_item = ref()
const paypal_product_item = ref()
const recharge_list = ref([])
const supportedPayTypes = ref([])
const user = ref(null)
const user_id = ref('')
const isNewUser = ref(false)
const orderId = ref('')
const clickPayItem = ref(null)
const { t } = useI18n()

const directPayTypes = computed(() => supportedPayTypes.value.filter(type => (
  ['PAYERMAX', 'STRIPE', 'DIANDIAN'].includes(type)
)))

const is_show_more = ref(false)
var chargeUid = 0

var initPayPalId = ''

let orderMap = {

}

function showMore() {
  is_show_more.value = !is_show_more.value
}

function goHome() {
  router.push('/')
}

function priceChangeHandle(item) {
  select_recharge_id.value = item.id
  select_recharge_item.value = item
  loadPaypalProductItem()
}

async function initPaypay(paypalOrderId) {

  var bizOrderId = ""

  return window.paypal
    .Buttons({
      // style: {
      //   // layout: 'vertical',
      //   color: 'silver',
      //   shape: 'pill',
      //   // label: 'paypal',
      //   disableMaxWidth: true,
      // },
      // async createOrder() {
      //   try {

      //     console.log(user)

      //     if (!user.value) {
      //       toastError("Please enter the user who needs to recharge!!!")
      //       return 0;
      //     }

      //     var requestBody = {
      //       product_id: select_recharge_id.value,
      //       pay_item_type: "PAYPAL",
      //       user_id: user.value.userId,
      //       v2: true
      //     }

      //     const orderRsp = await createOrder(requestBody)

      //     console.log("orderRsp == ", orderRsp)

      //     // orderMap[orderRsp.data.orderId] = orderRsp.data

      //     bizOrderId = orderRsp.data.orderId;

      //     var paypalOrderInfo = JSON.parse(orderRsp.data.payInfo.payInfoExtra.payExtra)


      //     orderMap[paypalOrderInfo.id] = orderRsp.data.orderId


      //     console.log('**orderMap :>> ', orderMap);

      //     return paypalOrderInfo.id;
      //   } catch (error) {
      //     console.error(error);
      //   }
      // },
      createOrder: () => paypalOrderId,
      onApprove: async (data, actions) => {
        try {
          console.log('onApprove data :>> ', data);
          var requestBody = {
            order_id: orderMap[data.orderID],
            user_id: user.value.userId,
            extra_json: JSON.stringify({
              paypalOrderId: data.orderID,
              packageName: "yay.chat.app"
            })
          }

          const rsp = await verifyReceipt(requestBody);

          console.log("result----", rsp)

          if (rsp.success) {
            toastSuccess(t('recharge.success.topUpSuccessful'))
          }

        } catch (error) {
          console.error(error);
        }
      },
    });
}

function hasPayChannel(channel) {
  return supportedPayTypes.value.includes(channel)
}


async function getProductList() {
  productsLoading.value = true
  try {
    let res = await getChargeProducts(user_id.value)
    if (res && res.success) {
      recharge_list.value = res.data.product
      supportedPayTypes.value = res.data.supportedPayTypes
      if (recharge_list.value.length > 0) {
        select_recharge_id.value = res.data.product[0].id
        select_recharge_item.value = res.data.product[0]
        loadPaypalProductItem()
      }
      if (!user_id.value) {
        nextTick(() => {
          loadPaypay(false)
        })
      }
    }
  } finally {
    productsLoading.value = false
  }
}


function checkUid(e) {
  // console.log(e.key)
  // let reg = /^[0-9]*$/
  // if (!reg.test(e.key)) {
  //   toastError('Invalid user ID')
  // }
  console.log(e)
  let str = e.target.value;
  let res;
  if (str[0] == 0) {
    user_id.value = str.substr(1);
  }
  user_id.value = user_id.value + '';
  user_id.value = user_id.value.replace(/[^\d]/g, '')

}

async function clearUserInput() {
  user_id.value = ''
  user.value = null
  isNewUser.value = false
  await getProductList()
}

async function saveUid(e, uid) {

  if (user.value && user.value == e.target.value) {
    return
  }
  if (e.target.value != null && e.target.value.length > 0) {
    chargeUid = e.target.value
    try {
      const res = await getUser({ user_id: chargeUid })
      if (res.success) {
        user.value = res.data;
        isNewUser.value = Boolean(res.data?.isNewUser ?? res.isNewUser)
        loadPaypay(user.value.isPaypalSandbox)
      } else {
        user.value = null
        isNewUser.value = false
        toastError(res.message)
      }
    } finally {
      await getProductList()
    }
  } else {
    user.value = null
    isNewUser.value = false
    await getProductList()
  }
}

async function getinfoByUid(uid) {
  chargeUid = uid

  if (chargeUid) {
    console.log(chargeUid)
    let res = await getUser({ user_id: chargeUid });
    if (res.success) {
      user.value = res.data;
      isNewUser.value = Boolean(res.data?.isNewUser ?? res.isNewUser)
      loadPaypay(user.value.isPaypalSandbox)
    } else {
      user.value = null
      isNewUser.value = false
      toastError(res.message)
    }
  }
}

function loadPaypay(isSandBox) {
  if (disablePaypal.value) {
    return
  }
  var cid = ""
  if (isSandBox) {
    cid = import.meta.env.VITE_PAYPAL_SANDBOX_CID
  } else {
    cid = import.meta.env.VITE_PAYPAL_CID
  }
  if (initPayPalId == cid) {
    return;
  }
  loadScript({ clientId: cid, currency: "USD" })
  initPayPalId = cid
}

async function stripePayClick() {
  if (!user.value) {
    toastError(t('recharge.errors.enterUserToRecharge'))
    return 0;
  }

  if (clickPayItem.value) {
    toastError(t('recharge.errors.pleaseWait'))
    return;
  }

  try {
    clickPayItem.value = "STRIPE"

    var requestBody = {
      product_id: select_recharge_id.value,
      pay_item_type: "STRIPE",
      user_id: user.value.userId,
      v2: true,
      extra: JSON.stringify({
        return_url: window.location.origin + '/recharge'
      })
    }
    loading.value = true

    console.log(requestBody)

    const rsp = await createOrder(requestBody)

    loading.value = false

    clickPayItem.value = null

    sessionStorage.setItem('__stp.od', JSON.stringify(rsp.data))
    sessionStorage.setItem('uid', user.value.userId)

    var stripeInfo = JSON.parse(rsp.data.payInfo.payInfoExtra.payExtra)

    router.push({ name: 'stripe', state: { stripeInfo } })
  } catch (error) {
    toastError(t('recharge.errors.topUpFailed'))
  } finally {
    loading.value = false
  }

}

async function payermaxClick() {
  if (!user.value) {
    toastError(t('recharge.errors.enterUserToRecharge'))
    return 0;
  }

  if (clickPayItem.value) {
    toastError(t('recharge.errors.pleaseWait'))
    return;
  }

  clickPayItem.value = "PAYERMAX"

  var requestBody = {
    product_id: select_recharge_id.value,
    pay_item_type: "PAYERMAX",
    user_id: user.value.userId,
    v2: true,
    extra: JSON.stringify({
      front_callback_url: window.location.origin + '/recharge'
    })
  }

  console.log(requestBody)

  try {
    loading.value = true
    const rsp = await createOrder(requestBody)

    clickPayItem.value = null

    loading.value = false

    if (rsp.success) {
      var payermaxInfo = JSON.parse(rsp.data.payInfo.payInfoExtra.payExtra)
      console.log('payermaxInfo--', payermaxInfo)
      window.location.href = payermaxInfo.redirectUrl
    } else {
      toastError(rsp.message ?? t('recharge.errors.createOrderFailed'))
    }
  } catch (e) {
    console.log(e)
    toastError(e)
  } finally {
    loading.value = false
  }

}

async function haipayClick() {
  if (!user.value) {
    toastError(t('recharge.errors.enterUserToRecharge'))
    return 0;
  }

  if (clickPayItem.value) {
    toastError(t('recharge.errors.pleaseWait'))
    return;
  }

  clickPayItem.value = "HAIPAY_USDT"

  var requestBody = {
    product_id: select_recharge_id.value,
    pay_item_type: "HAIPAY_USDT",
    user_id: user.value.userId,
    v2: true,
    extra: JSON.stringify({
      callback_url: window.location.origin + '/recharge'
    })
  }

  console.log(requestBody)

  try {
    loading.value = true
    const rsp = await createOrder(requestBody)

    clickPayItem.value = null

    loading.value = false

    if (rsp.success) {
      var haipayInfo = JSON.parse(rsp.data.payInfo.payInfoExtra.payExtra)
      console.log('HAIPAY_USDT--', haipayInfo)
      window.location.href = haipayInfo.payUrl
    } else {
      toastError(rsp.message ?? t('recharge.errors.createOrderFailed'))
    }
  } catch (e) {
    console.log(e)
    toastError(e)
  } finally {
    loading.value = false
  }

}

async function pinddpayClick() {
  if (!user.value) {
    toastError(t('recharge.errors.enterUserToRecharge'))
    return 0;
  }

  if (clickPayItem.value) {
    toastError(t('recharge.errors.pleaseWait'))
    return;
  }

  clickPayItem.value = "PINDD"

  var requestBody = {
    product_id: select_recharge_id.value,
    pay_item_type: "PINDD",
    user_id: user.value.userId,
    v2: true,
    extra: JSON.stringify({
      callback_url: window.location.origin + '/recharge'
    })
  }

  console.log(requestBody)

  try {
    loading.value = true
    const rsp = await createOrder(requestBody)

    clickPayItem.value = null

    loading.value = false

    if (rsp.success) {
      var pinddPayInfo = JSON.parse(rsp.data.payInfo.payInfoExtra.payExtra)
      console.log('PINDD--', pinddPayInfo)
      window.location.href = pinddPayInfo.result.payments[0].paylink
    } else {
      toastError(rsp.message ?? t('recharge.errors.createOrderFailed'))
    }
  } catch (e) {
    console.log(e)
    toastError(e)
  } finally {
    loading.value = false
  }

}

async function diandianPayClick() {
  if (!user.value) {
    toastError(t('recharge.errors.enterUserToRecharge'))
    return 0;
  }

  if (clickPayItem.value) {
    toastError(t('recharge.errors.pleaseWait'))
    return;
  }


  clickPayItem.value = "DIANDIAN"

  var requestBody = {
    product_id: select_recharge_id.value,
    pay_item_type: "DIANDIAN",
    user_id: user.value.userId,
    v2: true,
    extra: JSON.stringify({
      callback_url: window.location.origin + '/recharge'
    })
  }

  console.log(requestBody)

  try {
    loading.value = true
    const rsp = await createOrder(requestBody)

    clickPayItem.value = null

    loading.value = false

    if (rsp.success) {
      var payInfo = JSON.parse(rsp.data.payInfo.payInfoExtra.payExtra)
      console.log('DIANDIAN--', payInfo)
      window.location.href = payInfo.payLink
    } else {
      toastError(rsp.message ?? t('recharge.errors.createOrderFailed'))
    }
  } catch (e) {
    console.log(e)
    toastError(e)
  } finally {
    loading.value = false
  }

}

async function beforeStripeClick(item) {
  return stripePayClick()
  // if(item == 'DIANDIAN') {
  //   return diandianPayClick()
  // }else if(item == 'STRIPE') {
  //   return stripePayClick()
  // }
}

async function checkStripeSession(sessionId) {
  try {
    let stripeOrder = JSON.parse(sessionStorage.getItem('__stp.od'))
    let uid = sessionStorage.getItem('uid')
    if (!stripeOrder || !uid) {
      window.location.href = window.location.origin + window.location.pathname;
      return
    }

    dealSessionId(sessionId)

    var requestBody = {
      order_id: stripeOrder.orderId,
      user_id: uid,
      extra_json: JSON.stringify({
        session_id: sessionId,
        packageName: "yay.chat.app"
      })
    }

    console.log(requestBody)

    loading.value = true

    const rsp = await verifyReceipt(requestBody);

    loading.value = false
    sessionStorage.removeItem('__stp.od')
    if (rsp.success || rsp.code == 1001510117) {
      toastSuccess(t('recharge.success.topUpSuccessful'))
      window.location.href = window.location.origin + window.location.pathname + `?uid=${uid}`;
    } else {
      toastError(rsp.message ?? t('recharge.errors.topUpFailed'))
    }
  } catch (e) {
    toastError(e.toString())
  } finally {
    loading.value = false
  }

}

function hasDealSessionId(sessionId) {
  let rawIds = sessionStorage.getItem('ss.ids')
  if (rawIds) {
    let ids = JSON.parse(rawIds)
    return ids.includes(sessionId)
  } else {
    return false
  }
}

function dealSessionId(sessionId) {
  let rawIds = sessionStorage.getItem('ss.ids')
  if (!rawIds) {
    rawIds = JSON.stringify([sessionId])
  } else {
    let ids = JSON.parse(rawIds)
    ids.push(sessionId)
    rawIds = JSON.stringify(ids)
  }
  sessionStorage.setItem('ss.ids', rawIds)
}

async function checkPayermax(uid, orderId, tradeNo) {
  try {
    if (!tradeNo || !orderId || !uid) {
      window.location.href = window.location.origin + window.location.pathname;
      return
    }

    var requestBody = {
      order_id: orderId,
      user_id: uid,
      extra_json: JSON.stringify({
        outTradeNo: tradeNo,
        packageName: "yay.chat.app"
      })
    }

    console.log(requestBody)

    loading.value = true

    const rsp = await verifyReceipt(requestBody);

    loading.value = false

    if (rsp.success || rsp.code == 1001510117) {
      toastSuccess(t('recharge.success.topUpSuccessful'))
      setTimeout(() => {
        window.location.href = window.location.origin + window.location.pathname + `?uid=${uid}`;
      }, 1000)
    } else {
      toastError(rsp.message ?? t('recharge.errors.topUpFailed'))
    }
  } catch (e) {
    toastError(e.toString())
  } finally {
    loading.value = false
  }
}

async function checkPinddPay(uid, orderId, tradeNo) {
  try {
    if (!tradeNo || !orderId || !uid) {
      window.location.href = window.location.origin + window.location.pathname;
      return
    }

    var requestBody = {
      order_id: orderId,
      user_id: uid,
      extra_json: JSON.stringify({
        tradeNo,
        packageName: "yay.chat.app"
      })
    }

    console.log(requestBody)

    loading.value = true

    const rsp = await verifyReceipt(requestBody);

    loading.value = false

    if (rsp.success || rsp.code == 1001510117) {
      toastSuccess(t('recharge.success.topUpSuccessful'))
      setTimeout(() => {
        window.location.href = window.location.origin + window.location.pathname + `?uid=${uid}`;
      }, 1000)
    } else {
      toastError(rsp.message ?? t('recharge.errors.topUpFailed'))
    }
  } catch (e) {
    toastError(e.toString())
  } finally {
    loading.value = false
  }
}

async function checkDiandianPay(uid, orderId, ddid) {
  try {
    if (!ddid || !orderId || !uid) {
      window.location.href = window.location.origin + window.location.pathname;
      return
    }

    var requestBody = {
      order_id: orderId,
      user_id: uid,
      extra_json: JSON.stringify({
        diandianId: ddid,
        packageName: "yay.chat.app"
      })
    }

    console.log(requestBody)

    loading.value = true

    const rsp = await verifyReceipt(requestBody);

    loading.value = false

    if (rsp.success || rsp.code == 1001510117) {
      toastSuccess(t('recharge.success.topUpSuccessful'))
      setTimeout(() => {
        window.location.href = window.location.origin + window.location.pathname + `?uid=${uid}`;
      }, 1000)
    } else {
      toastError(rsp.message ?? t('recharge.errors.topUpFailed'))
    }
  } catch (e) {
    toastError(e.toString())
  } finally {
    loading.value = false
  }
}

async function asiapayClick() {
  if (!user.value) {
    toastError(t('recharge.errors.enterUserToRecharge'))
    return 0;
  }

  if (clickPayItem.value) {
    toastError(t('recharge.errors.pleaseWait'))
    return;
  }

  clickPayItem.value = "ASIAPAY"

  loading.value = true

  var requestBody = {
    product_id: select_recharge_id.value,
    pay_item_type: "ASIAPAY",
    user_id: user.value.userId,
    v2: true,
    extra: JSON.stringify({
      front_callback_url: window.location.origin + '/recharge'
    })
  }

  console.log(requestBody)

  try {
    const rsp = await createOrder(requestBody)
    clickPayItem.value = null

    loading.value = false

    if (rsp.success) {
      var asiapayConfig = JSON.parse(rsp.data.payInfo.payInfoExtra.payExtra)
      console.log('asiapayConfig--', asiapayConfig)
      const form = genrateForm(asiapayConfig)
      form.submit()
    } else {
      toastError(rsp.message ?? t('recharge.errors.createOrderFailed'))
    }
  } catch (e) {
    console.log(e)
    toastError(e)
  } finally {
    loading.value = false
  }
}


// getProductList();
onMounted(async () => {
  let queryValue = router.currentRoute.value.query
  const queryUid = Array.isArray(queryValue.uid) ? queryValue.uid[0] : queryValue.uid
  const callbackUid = queryValue.session_id ? sessionStorage.getItem('uid') : ''
  const normalizedUid = `${queryUid || callbackUid || ''}`.replace(/[^\d]/g, '')

  user_id.value = normalizedUid
  await getProductList()
  if (normalizedUid) {
    await getinfoByUid(normalizedUid)
  }

  console.log('onMounted---', queryValue)
  let isPayerMax = queryValue.payermax == 1
  let isPaypal = queryValue.paypal == 1
  let isPinddPay = queryValue.pinddpay == 1
  let isDiandianPay = queryValue.diandianpay == 1
  let sessionId = queryValue.session_id
  let isAsiapay = queryValue.asp == 1
  let aisapayState = queryValue.s
  let aisapayRef = queryValue.Ref
  if (sessionId && !hasDealSessionId(sessionId)) {
    let uid = sessionStorage.getItem('uid')
    user_id.value = uid
    loading.value = true
    checkStripeSession(sessionId)
  } else if (isPayerMax) {
    const status = queryValue.status
    if (status && status.toUpperCase() == 'SUCCESS') {
      user_id.value = queryValue.uid
      orderId.value = queryValue.orderId
      let tradeNo = queryValue.outTradeNo
      loading.value = true
      checkPayermax(user_id.value, orderId.value, tradeNo)
    }
  } else if (isAsiapay && aisapayState && aisapayRef) {
    console.log('is asiapay')
    let refJson = localStorage.getItem('__yy__asiap_ref')
    let refs = []
    if (refJson != null) {
      refs = JSON.parse(refJson)
    }
    if (!refs.includes(aisapayRef)) {
      refs.push(aisapayRef)
      if (aisapayState == 0) {
        toastSuccess(t('recharge.success.topUpSuccessful'))
      } else if (aisapayState == 1) {
        toastError(t('recharge.errors.topUpCanceled'))
      } else {
        toastError(t('recharge.errors.topUpFailed'))
      }
      localStorage.setItem('__yy__asiap_ref', JSON.stringify(refs))
    }

  } else if (isPaypal) {
    const state = queryValue.state
    if (queryValue.token && state == 0) { // paypal=1&yay_oid=%s&uid=%s
      checkPaypal(queryValue.yay_oid, queryValue.uid, queryValue.token)
    } else {
      toastError(t('recharge.errors.topUpFailed'))
    }
  }else if(isPinddPay) {
    const status = queryValue.payment_status
    if(status == 'paid') {
      user_id.value = queryValue.uid
      orderId.value = queryValue.orderId
      loading.value = true
      checkPinddPay(user_id.value, orderId.value, queryValue.trade_no)
    }
  }else if(isDiandianPay) {
    user_id.value = queryValue.uid
    orderId.value = queryValue.orderId
    const ddid = queryValue.ddid
    loading.value = true
    checkDiandianPay(user_id.value, orderId.value, ddid)
  }
})


async function customPaypalClick() {
  const paypalOrderInfo = await createPaypalOrder()
  const link = paypalOrderInfo.links.find((item) => item.rel == 'payer-action')
  console.log('link--', link)
  window.location.href = link.href
}

const percentConfig = {
  "STRIPE": 0.2,
  "PAYERMAX": 0.8,
  "PAYPAL": 0
}

function bankCardClick() {
  let percents = []
  for (let type of supportedPayTypes.value) {
    percents.push(percentConfig[type])
  }
  const payType = weightedRandom(supportedPayTypes.value, percents)
  if (payType == "STRIPE") {
    stripePayClick()
  } else if (payType == "PAYERMAX") {
    payermaxClick()
  }
}

async function createPaypalOrder() {
  try {

    console.log(user)

    if (!user.value) {
      toastError(t('recharge.errors.enterUserToRecharge'))
      return 0;
    }

    var requestBody = {
      product_id: select_recharge_id.value,
      pay_item_type: "PAYPAL",
      user_id: user.value.userId,
      v2: true,
      extra: JSON.stringify({
        return_url: window.location.origin + '/recharge',
        cancel_url: window.location.origin + '/recharge'
      })
    }

    loading.value = true

    const orderRsp = await createOrder(requestBody)

    loading.value = false

    let bizOrderId = orderRsp.data.orderId;

    var paypalOrderInfo = JSON.parse(orderRsp.data.payInfo.payInfoExtra.payExtra)

    console.log("paypalOrderInfo == ", paypalOrderInfo)

    orderMap[paypalOrderInfo.id] = orderRsp.data.orderId


    console.log('**orderMap :>> ', orderMap);

    return paypalOrderInfo;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false
  }
}

async function loadPaypalProductItem() {
  let res = await getChargeProductIten(select_recharge_id.value, "PAYPAL", user_id.value)
  if (res && res.success) {
    paypal_product_item.value = res.data
  }
}

async function checkPaypal(yayOrderId, uid, paypalOid) {
  try {
    console.log('checkPaypal data :>>', yayOrderId, uid, paypalOid);
    var requestBody = {
      order_id: yayOrderId,
      user_id: uid,
      extra_json: JSON.stringify({
        paypalOrderId: paypalOid,
        packageName: "yay.chat.app"
      })
    }

    loading.value = true

    const rsp = await verifyReceipt(requestBody);

    console.log("checkPaypal - result----", rsp)

    loading.value = false

    if (rsp.success) {
      toastSuccess(t('recharge.success.topUpSuccessful'))
      setTimeout(() => {
        window.location.href = window.location.origin + window.location.pathname + `?uid=${uid}`;
      }, 1000)
    } else {
      toastError(t('recharge.errors.topUpFailed'))
    }
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false
  }
}

</script>

<style lang="scss" scoped>
/* 全局禁用横向滚动 */
* {
  box-sizing: border-box;
  max-width: 100%;
}

/* 确保根容器不会溢出 */
html,
body {
  overflow-x: hidden;
  max-width: 100%;
}

.page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(to right top, #4843FE, #FF5FB1);
  padding-top: 224px;
  box-sizing: border-box;
  padding-bottom: 100px;
  overflow-x: hidden;
}

.recharge-header {
  position: absolute;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #F1F1F1;
  background: #FFFFFF;
}

.recharge-brand {
  height: 36px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  color: #111111;
  background: transparent;
  font-family: "Poppins";
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;

  img {
    width: 36px;
    height: 36px;
    border-radius: 10px;
  }
}

.container {
  position: absolute;
  width: 100%;
  max-width: 100%;
  // min-height: 800px;
  background-color: white;
  // position: relative;
  // left: 0;
  // right: 0;
  // margin: 0 auto;
  // top: 200px;
  border-radius: 30px;
  padding: 20px;
  z-index: 4;
  box-sizing: border-box;
  overflow-x: hidden;
}

.c_out {
  position: relative;
  width: 60%;
  // min-height: 800px;
  // background-color: white;
  left: 0;
  right: 0;
  margin: 0 auto;
  // top: -100px;
  // // top: 200px;
  // border-radius: 30px;
  // padding: 20px;
  // z-index: 4;

}

.first-bg {
  position: absolute;
  z-index: 2;
  top: -128px;
  left: 0;
  width: 100%;
  height: 180px;
  padding: 28px 300px 0 48px;
  border-radius: 30px;
  color: #ffffff;
  background: linear-gradient(103deg, #0719ff 2%, #bb00ff 91%);

  .card-title {
    color: #FBEB03;
    font-size: 30px;
    font-weight: 900;
    line-height: 36px;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .card-description {
    max-width: 480px;
    font-size: 17px;
    font-weight: 500;
    line-height: 22px;
  }

  .gift-icon {
    position: absolute;
    top: -24px;
    right: 24px;
    width: 250px;
    height: auto;
  }
}

.rechage_item {
  position: relative;
  width: 150px;
  height: 80px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #F6F7F7;
  box-sizing: border-box;
  flex-direction: column;
  margin-right: 10px;
  margin-bottom: 10px;
  // flex: 1;
  // flex-shrink: 1;

  &.active {
    background:
      linear-gradient(110deg, #F9E8FF, #E9E6FF) padding-box,
      linear-gradient(110deg, #FF41FF, #6922FF) border-box;
  }

  .row1 {
    align-items: center;
    font-size: 25px;
    font-weight: 600;

    img {
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }

    &.active {
      background-image: linear-gradient(#FF5FB1, #4843FE); // 背景线性渐变
      color: #ffffff; // 兜底颜色，防止文字裁剪不生效
      background-clip: text;
      -webkit-background-clip: text; // 背景被裁减为文字的前景色
      -webkit-text-fill-color: transparent; // 文字填充为透明，优先级比color高。
    }
  }

  .row2 {
    font-size: 18px;
    color: #999;
    font-weight: normal;
  }
}

.pc-coin-skeletons {
  gap: 10px;
}

.pc-coin-skeleton {
  flex: 0 0 150px;
  width: 150px;
  height: 80px;
  border-radius: 12px;
}

.pc-payment-skeletons {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pc-payment-skeleton {
  width: 100%;
  height: 48px;
  border-radius: 30px;
}

.skeleton-shimmer {
  display: block;
  background: linear-gradient(100deg, #EEEEEE 25%, #FFFFFF 42%, #EEEEEE 59%);
  background-size: 220% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
  font-family: "Poppins";
}

.row {
  margin-bottom: 30px;

  .label {
    font-size: 25px;
    font-weight: 600;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .value {
    flex-wrap: wrap;
  }
}

#top_up_btn {
  width: 100%;
}

.uid_input {
  width: 100%;
  height: 100%;
  padding: 0 42px 0 13px;
  border: 0;
  border-radius: 12px;
  outline: 0;
  color: #333333;
  background: transparent;
  font-size: 14px;
  font-weight: 700;

  &::placeholder {
    color: #C0C0C0;
    font-weight: 400;
    opacity: 1;
  }
}

.circle_avatar {
  flex: 0 0 32px;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.desktop-account-card {
  width: min(100%, 460px);
  min-height: 72px;
  margin: 0 auto;
  padding: 12px;
  border-radius: 16px;
  background: #F6F7F7;

  &.has-user {
    min-height: 112px;
  }
}

.desktop-input-wrap {
  position: relative;
  height: 48px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #FFFFFF;

  &.active {
    border-color: #FF41FF;
  }
}

.clear-user-button {
  position: absolute;
  top: 50%;
  right: 13px;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #C8C8C8;
  transform: translateY(-50%);
  cursor: pointer;

  span::before,
  span::after {
    position: absolute;
    top: 8px;
    left: 4px;
    width: 10px;
    height: 2px;
    border-radius: 1px;
    background: #FFFFFF;
    content: '';
  }

  span::before {
    transform: rotate(45deg);
  }

  span::after {
    transform: rotate(-45deg);
  }
}

.desktop-user-info {
  height: 32px;
  margin: 8px 13px 0;
  display: flex;
  align-items: center;
  min-width: 0;
}

.desktop-user-name {
  min-width: 0;
  margin-left: 10px;
  overflow: hidden;
  color: #333333;
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.first-top-up {
  flex: 0 0 auto;
  height: 20px;
  margin-left: 8px;
  padding: 0 7px;
  border-radius: 4px;
  color: #ffffff;
  background: linear-gradient(90deg, #FC1192, #FE8F19);
  font-size: 11px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
}

.user_title {
  margin-top: 10px;
  font-size: 14;
  font-weight: 600;
}

.coin_bg {
  position: absolute;
  right: -270px;
  top: -162px;
  z-index: 1;

  @media screen and (max-width: 767px) {
    display: none;
    /* 移动端隐藏装饰图片避免横向滚动 */
  }
}

@media screen and (max-width: 1200px) {
  .first-bg {
    padding-right: 230px;
    padding-left: 36px;

    .card-title {
      font-size: 24px;
      line-height: 31px;
    }

    .card-description {
      font-size: 15px;
      line-height: 20px;
    }

    .gift-icon {
      right: 12px;
      width: 215px;
    }
  }
}

.border-box {
  width: 100px;
  height: 40px;
  border: 4px solid transparent;
  border-radius: 25px;
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
  background-image: linear-gradient(to right, #333, #333), linear-gradient(0deg, rgb(174, 111, 255) 0%, rgb(46, 179, 255) 100%);
}




@media screen and (max-width:767px) {
  .page {
    padding-top: 100px;
  }

  .c_out {
    width: 95%;
    max-width: 100%;
    min-height: calc(100vh - 100px);
    /* 增加可用空间 */
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .rechage_item {
    width: 46%;
  }

  .rechage_item:nth-child(2n) {
    margin-right: 0;
  }

  .container {
    padding: 15px;
    margin: 0;
  }

  /* 确保所有内容不会横向溢出 */
  .title,
  .label,
  .uid_input,
  .stripe-pay-btn,
  .payermax-btn,
  .custom_paypal_btn {
    max-width: 100%;
    box-sizing: border-box;
    word-wrap: break-word;
  }

  /* 确保按钮内容不溢出 */
  .inline-layout,
  .btn_con {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.payermax-btn {
  width: 100%;
  height: 48px;
  border: 1px solid transparent;
  border-radius: 30px;
  color: #333333;
  background:
    linear-gradient(90deg, rgba(72, 67, 254, 0.12) 0%, rgba(255, 75, 167, 0.12) 100%) padding-box,
    linear-gradient(#FFFFFF, #FFFFFF) padding-box,
    linear-gradient(90deg, #4843FE 0%, #FF4BA7 100%) border-box;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 6px 0px;
  position: relative;

  .icon_suggest {
    width: 94px;
    height: 40px;
    position: absolute;
    right: 0;
    top: -30px;
  }


  .icon {
    height: 28px;
    width: 28px;
    margin-right: 8px;
  }

  .card_flag {
    width: 97px;
    height: 32px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    right: 0px;
    top: -20px;
    font-size: 11px;
    font-weight: 600;
    font-style: normal;
    color: white;
    background-image: url('../../assets/img/flag_bank_card.webp');
    background-size: cover;

    span {
      margin-top: 13px;
      margin-left: 28px;
    }
  }
}

.tt {
  width: 100%;
  height: 46px;
  object-fit: fill;
  background-color: #3498db;
}

.aisapay-btn {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 23px;
  background: #01B0F190;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 6px 0px;

}

.paydollar-icon {
  height: 24px;
  margin-right: 8px;
}

.stripe-pay-btn {
  width: 100%;
  height: 48px;
  border: 1px solid transparent;
  border-radius: 30px;
  background:
    linear-gradient(90deg, rgba(72, 67, 254, 0.12) 0%, rgba(255, 75, 167, 0.12) 100%) padding-box,
    linear-gradient(#FFFFFF, #FFFFFF) padding-box,
    linear-gradient(90deg, #4843FE 0%, #FF4BA7 100%) border-box;
  color: #333;
  font-family: "Poppins";
  font-weight: 700;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-style: italic;
  margin: 6px 0px;
  position: relative;

  .icon_suggest {
    width: 94px;
    height: 40px;
    position: absolute;
    right: 0;
    top: -30px;
  }

  .icon {
    width: 28px;
    height: 28px;
    margin-right: 8px;
  }

  .card_flag {
    width: 83px;
    height: 18px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    right: 0px;
    top: -8px;
    font-size: 11px;
    font-weight: 600;
    font-style: normal;
    background-image: url('../../assets/img/flag_paypal.webp');
    background-size: cover;
  }

}


.inline-layout {
  display: inline-flex;
  justify-content: center;
  align-items: center;

  &.loading {
    opacity: 0.5;
  }

  span {
    color: white;
  }
}

// .stripe-pay-btn:hover {
//   opacity: 0.8;
// }

.stripe-pay-btn:active {
  background-color: #E1E1E1;
}

.loading-overlay {
  position: fixed;
  /* 固定定位 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明背景 */
  display: flex;
  flex-direction: column;
  color: white;
  font-size: 16px;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
  z-index: 1000;
  /* 确保它在最上面 */
}


/* Base style for the loader */
.loader {
  border: 5px solid #f3f3f3;
  /* Light grey border */
  border-top: 5px solid #3498db;
  /* Blue border */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin-bottom: 16px;
}

/* Animation for spinning effect */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes skeleton-shimmer {
  to {
    background-position-x: -220%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton-shimmer {
    animation: none;
  }
}

.button-container {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: "Poppins";
  font-weight: 700;
  font-style: italic;

  @media screen and (max-width: 767px) {
    max-height: 55vh;
    /* 增加最大高度以容纳更多支付方式 */
    overflow-y: auto;
    padding: 12px 0;
    -webkit-overflow-scrolling: touch;
    /* 平滑滚动 */

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(to bottom, #4843FE, #FF4BA7);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(to bottom, #5843FF, #FF4BF9);
    }

    /* 为更多支付方式优化显示 */
    .pay-method-item {
      margin-bottom: 8px;
      /* 减少间距以容纳更多选项 */
    }

    /* 添加底部渐变指示器，提示用户可以滚动 */
    &::after {
      content: "";
      position: sticky;
      bottom: 0;
      display: block;
      height: 20px;
      background: linear-gradient(to top, rgba(255, 255, 255, 0.9), transparent);
      pointer-events: none;
      z-index: 10;
    }
  }
}

.pay-method-item {
  width: 100%;
  margin-bottom: 10px;

  @media screen and (max-width: 767px) {
    margin-bottom: 12px;

    /* 确保按钮在小屏幕上有足够的触摸区域 */
    .stripe-pay-btn,
    .payermax-btn,
    .custom_paypal_btn {
      min-height: 48px;
      /* 稍微减少高度以容纳更多选项 */
      font-size: 14px;
      padding: 6px 12px;
      margin: 4px 0;

      /* 增强触摸反馈 */
      &:active {
        transform: scale(0.98);
        transition: transform 0.1s ease;
      }
    }

    /* 优化支付按钮内容布局 */
    .inline-layout {
      flex-wrap: nowrap;

      span {
        font-size: 14px;
      }
    }

    .btn_con {
      min-width: auto;

      span {
        font-size: 14px;
      }
    }
  }
}

.click-loading {
  border: 2px solid white;
  /* 浅灰色边框 */
  border-top: 2px solid #818181;
  /* 蓝色边框 */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  animation: spin 0.8s linear infinite;
  transform: translate(-50%, -50%);
}

.show-more {
  width: 100%;
  height: auto;
  min-height: 44px;
  transition: 0.3s;
  flex-direction: column;
  justify-content: start;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  span {
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
  }

  img {
    display: inline-block;
    width: 14px;
    height: 9px;
    margin-left: 6px;
  }
}

.long-box {
  min-height: 250px;
  transition: 0.3s;
}

.short-box {
  min-height: 80px;
  transition: 0.3s;
}

.rotate180 {
  transform: rotate(180deg);
}

.load-btn {
  position: absolute;
  bottom: 0;
  cursor: pointer;
}

// #top_up_btn {
//   position: absolute;
//   top: 50px;
// }

.op-trans {
  opacity: 1.0;
  transition: 0.6s;
}

.more-hidden-item {
  width: 100%;
  position: absolute;
  top: 0px;
  opacity: 0.0;

  &.show {
    opacity: 1.0;
    transition: 0.6s;
  }
}

.gradient-text {
  font-size: 16px;
  font-weight: 900;
  padding: 0px 5px;
  box-sizing: border-box;
  background-image: linear-gradient(to right, #4843FE, #FF4BA7); // 背景线性渐变
  color: #ffffff; // 兜底颜色，防止文字裁剪不生效
  background-clip: text;
  -webkit-background-clip: text; // 背景被裁减为文字的前景色
  -webkit-text-fill-color: transparent; // 文字填充为透明，优先级比color高。
}

.bank_card_btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 24px;
  color: white;
  font-weight: 600;
  display: flex;
  font-style: normal;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  font-size: 16px;
  position: relative;
  background: linear-gradient(to right, #4843FE, #FF4BA7); // 背景线性渐变;

  img {
    width: 24px;
    height: 20px;
    margin-right: 12px;
  }

  .card_flag {
    width: 97px;
    height: 32px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
      align-items: flex-start;
    right: 0px;
    top: -20px;
    font-size: 11px;
    font-weight: 600;
    background-image: url('../../assets/img/flag_bank_card.webp');
    background-size: cover;

    span {
      margin-top: 13px;
      margin-left: 28px;
    }
  }
}

.bank_card_btn:hover {
  background: linear-gradient(to right, #5843FF, #FF4BF9); // 背景线性渐变;
}

.bank_card_btn:active {
  opacity: 0.8;
}

.custom_paypal_btn {
  width: 100%;
  height: 48px;
  border: 1px solid transparent;
  border-radius: 30px;
  color: #ffffff;
  font-weight: 700;
  display: flex;
  font-style: italic;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin-bottom: 10px;
  position: relative;
  background:
    linear-gradient(90deg, rgba(72, 67, 254, 0.12) 0%, rgba(255, 75, 167, 0.12) 100%) padding-box,
    linear-gradient(#FFFFFF, #FFFFFF) padding-box,
    linear-gradient(90deg, #4843FE 0%, #FF4BA7 100%) border-box;

  span{
    color: #333;
  }

  img {
    width: 28px;
    height: 28px;
    margin-right: 8px;
  }

  .card_flag {
    width: 83px;
    height: 18px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    right: 0px;
    top: -8px;
    font-size: 11px;
    font-weight: 600;
    font-style: normal;
    background-image: url('../../assets/img/flag_paypal.webp');
    background-size: cover;
  }
}

// .custom_paypal_btn:hover {
//   background-color: #4d2fcf;
// }

.custom_paypal_btn:active {
  opacity: 0.8;
}

.btn_con {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 185px;
}

/* 隐藏PayPal容器 */
#paypal-container {
  position: absolute;
  visibility: hidden;
  height: 0;
  width: 0;
  overflow: hidden;
}

.raw-price {
  font-family: "Poppins";
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0;
  color: white;
  text-decoration: line-through;
  margin-left: 5px;
}

@media screen and (min-width: 1081px) {
  .page {
    min-height: 100vh;
    padding: clamp(176px, 21vh, 240px) 32px 72px;
    background:
      linear-gradient(rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08)),
      url('@/img/recharge/yaychat_recharge_bg.webp') center / 100% 100% no-repeat,
      #F1EFFF;
  }

  .recharge-header {
    height: 96px;
    padding: 28px 64px 0;
    align-items: flex-start;
    border: 0;
    background: transparent;
  }

  .recharge-brand {
    height: 48px;
    gap: 14px;
    font-size: 28px;
    font-weight: 800;

    img {
      width: 48px;
      height: 48px;
      border-radius: 14px;
    }
  }

  .c_out {
    position: relative;
    width: min(1068px, calc(100vw - 64px));
    margin: 0 auto;
    left: auto;
    right: auto;
  }

  .first-bg {
    position: relative;
    z-index: 1;
    top: auto;
    left: auto;
    width: 100%;
    height: 176px;
    padding: 34px 410px 0 150px;
    border-radius: 48px 48px 0 0;
    background: linear-gradient(103deg, #0719FF 2%, #BB00FF 91%);

    .card-title {
      font-size: 30px;
      line-height: 36px;
    }

    .card-description {
      max-width: 500px;
      font-size: 16px;
      line-height: 21px;
      white-space: nowrap;
    }

    .gift-icon {
      top: -42px;
      right: 145px;
      width: 260px;
    }
  }

  .container {
    position: relative;
    z-index: 2;
    width: 100%;
    min-height: 624px;
    margin-top: -50px;
    padding: 66px 128px 48px;
    overflow: visible;
    border-radius: 48px;
    background: #FFFFFF;
  }

  .title {
    display: none;
  }

  .container > .row {
    margin: 0;
  }

  .desktop-account-section {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .desktop-account-label {
    margin-bottom: 14px;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
  }

  .desktop-account-card {
    width: 480px;
    min-height: 48px;
    padding: 0;
    border-radius: 12px;
    background: transparent;

    &.has-user {
      height: 100px;
      min-height: 100px;
      padding: 12px;
      box-sizing: border-box;
      border-radius: 16px;
      background: #F6F7F7;
    }
  }

  .desktop-input-wrap {
    height: 48px;
    border-radius: 12px;
    background: #F1F1F1;
  }

  .desktop-account-card.has-user .desktop-input-wrap {
    background: #FFFFFF;
  }

  .desktop-user-info {
    margin-right: 13px;
  }

  .container > .row:first-of-type > .label {
    margin: 44px 0 18px;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
  }

  .value {
    width: 100%;
    display: grid !important;
    grid-template-columns: repeat(5, 150px);
    gap: 16px;
    justify-content: center;
  }

  .rechage_item,
  .pc-coin-skeleton {
    width: 150px;
    height: 100px;
    margin: 0;
    border-radius: 16px;
  }

  .rechage_item {
    background: #F1F1F1;

    > div {
      width: 150px !important;
    }

    .row1 {
      font-size: 24px;
      line-height: 29px;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .row2 {
      margin-top: 8px;
      color: #999999;
      font-size: 14px;
      line-height: 17px;
    }
  }

  .container > .row:last-of-type {
    margin-top: 36px;

    > .label {
      display: none;
    }
  }

  .button-container {
    width: 480px;
    margin: 0 auto;
  }

  .pc-payment-skeletons {
    gap: 12px;
  }

  .pc-payment-skeleton {
    height: 48px;
  }

  .pay-method-item {
    width: 100%;
    margin: 0 0 12px;
  }

  .stripe-pay-btn,
  .payermax-btn,
  .custom_paypal_btn {
    width: 100%;
    height: 48px;
    margin: 0;
    border: 1px solid transparent;
    border-radius: 30px;
    color: #222222;
    background:
      linear-gradient(90deg, rgba(72, 67, 254, 0.12) 0%, rgba(255, 75, 167, 0.12) 100%) padding-box,
      linear-gradient(#FFFFFF, #FFFFFF) padding-box,
      linear-gradient(90deg, #4843FE 0%, #FF4BA7 100%) border-box;
    box-shadow: none;
    font-style: normal;
  }

  .inline-layout,
  .btn_con {
    min-width: 0;
    justify-content: center;
    font-style: normal;

    > span {
      color: #111111;
      font-family: "Poppins";
      font-size: 14px;
      font-weight: 600;
      font-style: normal;
      line-height: 100%;
      letter-spacing: 0;
    }
  }

  .stripe-pay-btn .icon,
  .payermax-btn .icon,
  .custom_paypal_btn img {
    width: 28px;
    height: 28px;
  }

  .raw-price {
    color: rgba(51, 51, 51, 0.32) !important;
  }

  .pc-coin-skeleton,
  .pc-payment-skeleton {
    background: linear-gradient(100deg, #EEEEEE 25%, #FFFFFF 42%, #EEEEEE 59%);
    background-size: 220% 100%;
  }
}

@media screen and (min-width: 1081px) and (max-width: 1200px) {
  .container {
    padding-right: 80px;
    padding-left: 80px;
  }
}
</style>
